var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"designer-platform"},[_c('Header'),_vm._v(" "),_c('Aside'),_vm._v(" "),_c('Main',[_c('div',{staticStyle:{"width":"100%","height":"100%"},attrs:{"slot":"DesignerPlatformMain"},slot:"DesignerPlatformMain"},[_c('nuxt')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }